<template>
  <div class="products">
    <InnerHeader :cover="img" :bgColor="bg" :links="links" :bgPosition="'0 50%'"/>
    <Products v-if="!$route.query.page"/>
    <Zn v-else-if="$route.query.page == 'zn'" :color="this.bg"/>
    <Pb v-else-if="$route.query.page == 'pb'" :color="this.bg"/>
    <Au v-else-if="$route.query.page == 'au'" :color="this.bg"/>
    <Ag v-else-if="$route.query.page == 'ag'" :color="this.bg"/>
    <Ch v-else-if="$route.query.page == 'ch'" :color="this.bg"/>
  </div>
</template>

<script>
import InnerHeader from '../shared/InnerHeader';
import Products from './Products';
import Zn from './individuals/Zn';
import Pb from './individuals/Pb';
import Au from './individuals/Au';
import Ag from './individuals/Ag';
import Ch from './individuals/Ch';
export default {
  components: {
    InnerHeader,
    Products,
    Zn,
    Pb,
    Au,
    Ag,
    Ch
  },
  data() {
    return {
      img: require('../../assets/img/products/cover.jpg'),
      bg: '#4E4E4E'
    };
  },
  computed: {
    links() {
      return [
        {
          name: this.$t('nav3-1'),
          url: '/products',
          active: ['/products?scroll=productsChartWrapper']
        },
        {
          name: this.$t('nav3-2'),
          url: '/products?page=zn'
        },
        {
          name: this.$t('nav3-3'),
          url: '/products?page=pb'
        },
        {
          name: this.$t('nav3-4'),
          url: '/products?page=au'
        },
        {
          name: this.$t('nav3-5'),
          url: '/products?page=ag'
        },
        {
          name: this.$t('nav3-6'),
          url: '/products?page=ch'
        }
      ];
    }
  },
  watch: {
    '$route.query'() {
      this.updateHeader();
    }
  },
  methods: {
    updateHeader() {
      const query = this.$route.query;
      if (query.page === 'zn') {
        this.img = require('../../assets/img/products/bg_zn.jpg');
        this.bg = '#006D6F';
      } else if (query.page === 'pb') {
        this.img = require('../../assets/img/products/bg_pb.jpg');
        this.bg = '#F58220';
      } else if (query.page === 'au') {
        this.img = require('../../assets/img/products/bg_au.jpg');
        this.bg = '#D5AB45';
      } else if (query.page === 'ag') {
        this.img = require('../../assets/img/products/bg_ag.jpg');
        this.bg = '#A8A8A8';
      } else if (query.page === 'ch') {
        this.img = require('../../assets/img/products/bg_ch.jpg');
        this.bg = '#4168B1';
      } else {
        this.img = require('../../assets/img/products/cover.jpg');
        this.bg = '#4E4E4E';
      }
    }
  },
  mounted() {
    this.updateHeader();
    document.title = this.$t('title3');
  },
  destroyed() {
    document.title = this.$t('title0');
  }
};
</script>

<style>
</style>
